import styled from "styled-components/native";
import { Animated } from "react-native";

import { pickThemeKey as theme, pickSizeKey as size } from "utils";

export const Container = styled.View`
  background-color: #ecf0f1;
`;
export const StepProgress = styled.View`
  height: ${size("progress_bar")}px;
  width: 100%;
  background-color: ${theme("progress_bar_bg")};
  z-index: 1;
`;

export const FillOverlay = styled(Animated.View)`
  height: 100%;
  background-color: ${theme("progress_bar_fg")};
  z-index: 2;
  position: absolute;
`;

export const Percentage = styled.Text`
  color: ${theme("progress_bar_text")};
  font-size: ${size("progress_bar_text")};
  text-align: center;
  font-weight: bold;
  z-index: 5px;
`;
